import styled, { css } from 'styled-components';
import {
  PRIMARY_COLOR,
  SECONDARY_COLOR, SECONDARY_COLOR_2,
  SECONDARY_COLOR_3,
  SECONDARY_COLOR_4,
  SECONDARY_COLOR_5,
  SECONDARY_COLOR_6
} from '../../const/color';
import { FAMILY_FONT_CONTROL, FAMILY_FONT_PRIMARY, TITLE_SIZE_5 } from '../../const/text';
import { device } from '../../const/device';


export const Item = styled.div<{ active?: boolean, small?: boolean, compact?: boolean }>`
  display: flex;
  min-width: 58px;
  width: ${props => props.small ? 88 : 104}px;
  height: 40px;
  background-color: ${props => props.active ? SECONDARY_COLOR : SECONDARY_COLOR_6};
  font-weight: ${props => props.active ? 'bold' : 'normal'};
  font-size: 14px;
  font-family: ${FAMILY_FONT_CONTROL};
  color: ${props => props.active ? 'white' : SECONDARY_COLOR};
  cursor: ${props => props.active ? 'default' : 'pointer'};
  border: 1px solid ${props => props.active ? SECONDARY_COLOR : SECONDARY_COLOR_3};
  border-right: none;
  
  align-items: center;
  justify-content: center;
  
  &:last-child {
    border-right: 1px solid ${props => props.active ? SECONDARY_COLOR : SECONDARY_COLOR_3};
    border-radius: 0 2px 2px 0;
  }
  &:first-child {
    border-radius: 2px 0 0 2px;
  }
  
  ${props => !props.small ? css`
    flex: 1 1 104px;
  ` : ''}
  
  ${props => !props.active ? css`
    &:hover {
      background-color: ${SECONDARY_COLOR_5};
    }
  ` : ''}
  
  ${props => !props.compact && props.active ? css`
    background-color: ${SECONDARY_COLOR};
    color: ${SECONDARY_COLOR_6};
  ` : ''}
  ${props => !props.compact && !props.active ? css`
    background-color: ${SECONDARY_COLOR_6};
    color: ${SECONDARY_COLOR};
  ` : ''}
`;
export const Container = styled.div<{ compact?: boolean }>`
  display: inline-flex;
  flex-direction: row;
  width: 100%;
  overflow-x:auto;
  overflow-y:hidden;
  padding-bottom:7px;
  flex-wrap:wrap;
  
  &::-webkit-scrollbar {
    height:3px;
  }

  &::-webkit-scrollbar-thumb {
    background:${SECONDARY_COLOR};
  }
  
  
  ${props => props.compact ? css`
    ${Item} {
      height: 32px;
      border: none;
      border-radius: 2px;
      font-size: 12px;
      font-weight: normal;
      text-transform: uppercase;
      font-family: ${FAMILY_FONT_PRIMARY};
    }
    ${Item}:not(:last-child) {
      margin-right: 8px;
    }
  ` : ''}


  @media(${device.tabletM}){
    flex-wrap:nowrap;
  }
  
`;

export const ItemCircle = styled.div<{ active?: boolean }>`
  display: flex;
  
  align-items: center;
  justify-content: center;
  font-size: ${TITLE_SIZE_5}px;
  border-radius: 50%;
  min-width: 40px;
  height: 40px;
  color: ${SECONDARY_COLOR};
  background-color: ${SECONDARY_COLOR_6};
  cursor: pointer;
  margin-bottom:16px;
  
  &:not(:last-child) {
    margin-right: 16px;
  }
  
  @media (${device.tabletM}) {
    margin-bottom:0px;
  }

  @media (${device.mobileL}) {
    min-width: 32px;
    height: 32px;
  }
  
  ${props => props.active ? css`
    color: white;
    background-color: ${SECONDARY_COLOR};
  ` : css`
    &:hover {
      background-color: ${SECONDARY_COLOR_4};
    }
  `}
`;

export const ItemSizePreview = styled.div<{ preview: string, active: boolean, themeColor?: string }>`
  background: url(${props => props.preview}) top / 96px no-repeat;
  width: 96px;
  height: 76px;
  border-radius: 50%;
  margin-right: 30px;
  margin-bottom: 30px;
  background-clip: padding-box;
  padding-top: 96px;
  position: relative;
  text-align: center;
  font-family: ${FAMILY_FONT_CONTROL};
  color: ${SECONDARY_COLOR_2};
  cursor: pointer;

  &:after {
    content: '';
    position: absolute;
    width: 96px;
    height: 96px;
    top: 0;
    left: 0;
    border-radius: 50%;
    border: 4px solid transparent;
  }
  
  &:hover:after {
    border-bottom: 4px solid ${PRIMARY_COLOR};
  }
  
  ${props => props.active ? css`
    color: ${props.themeColor == "black" ? '#ffffff' : SECONDARY_COLOR};
    &:after {
      border-bottom: 4px solid ${PRIMARY_COLOR};
    }
  ` : ''}}
  
  
  
  @media (${device.tablet}) {
    margin-right: 48px;
  }

  @media (${device.tabletS}) {
    background: url(${props => props.preview}) top / 64px no-repeat;
    width: 64px;
    height: 64px;
    margin-right: 20px;
    margin-bottom: 30px;
    padding-top: 64px;
    &:after {
      width: 64px;
      height: 64px;
    }
  }

  @media (${device.mobileL}) {
    width: 64px;
    background: url(${props => props.preview}) top / 64px no-repeat;
    padding-top: ${64}px;
    &:last-child {
      margin-right: 0;
    }
    &:after {
      width: 64px;
      height: 64px;
    }
  }
`;
